import React from 'react';
import { Tabs, Tab, Grid, Divider } from '@material-ui/core';

import { ClientCutoutModalTabs } from '../../enums/ClientCutoutModalTabs';
import { theme } from '../../../../theme';
import { ClientErrorContext } from '../../ClientErrorContext';

interface ICutoutModalMenuProps {
    currentTab: ClientCutoutModalTabs,
    setCurrentTab: (tab: ClientCutoutModalTabs) => void,
}

export function CutoutModalMenu({ currentTab, setCurrentTab }: ICutoutModalMenuProps) { 

    const clientErrorContext = React.useContext(ClientErrorContext);

    return (
        <Grid item xs={12} style={{ marginBottom: theme.spacing(3) }}>
            <Tabs
                value={currentTab}
                indicatorColor="primary"
                textColor="primary"
                onChange={(_, cutoutPage: ClientCutoutModalTabs) => setCurrentTab(cutoutPage)}>
                <Tab
                    value={ClientCutoutModalTabs.ORGANOGRAM}
                    label={
                        <span style={{
                            color: clientErrorContext.organogramNotSelectedInCutoutError
                                ? theme.palette.error.main
                                : theme.palette.text.secondary }}>
                            Organograma
                        </span>} />
                <Tab
                    value={ClientCutoutModalTabs.TAGS}
                    label='Tags' />
                <Tab
                    value={ClientCutoutModalTabs.VEHICLE}
                    label='Veículo' />
            </Tabs>
            <Divider />
        </Grid>
    );
}